<template lang="pug">
v-flex
  v-card.card.pb-4(height="100%")
    v-layout(column v-if="isFormDataLoading").pa-0
      v-layout(wrap)
        v-flex(xs12)
          div.skeleton-loader
      v-divider(xs12).pb-1
      v-layout(wrap)
        v-flex(xs6)
          v-layout(row wrap)
            v-flex(xs12)
              div.skeleton-loader
            v-flex(xs6)
              div.skeleton-loader
          v-layout(row wrap)
            v-flex(xs4)
              div.skeleton-loader
            v-flex(xs8)
              div.skeleton-loader
        v-flex(xs6).pl-4
          v-layout(row wrap)
            v-flex(xs4)
              div.skeleton-loader
            v-flex(xs9)
              p.skeleton-box.mt-3
    v-layout(column v-else).pa-0
      v-form(
          ref="form"
          v-model="valid"
        )
        v-layout(wrap)
          v-flex(xs12)
            .headline.pb-3.font-weight-bold SMS Consent form builder
            div Type your information to generate your SMS consent form link:
          v-flex(v-if="formURL")
            div.box.pa-4
              a(:href="formURL" target="_blank").link {{ formURL }}
        v-divider(xs12).pb-1
        v-layout(wrap)
          v-flex(xs6)
            v-layout(row wrap)
              v-flex(xs12)
                div.inline-content Your brand/business name: 
                div.inline-content.v-label.font-weight-bold.mt-2 {{ form.brandName }}
              v-flex(xs12).pb-0
                div.inline-content Customer care contact information:
              v-flex(xs12 sm12 md12 lg10 xl6 style="margin-top: -23px")
                v-text-field(
                  v-model="form.customerCareContact"
                  :rules="[rules.required]"
                  placeholder="e.g., Reply HELP for help or call us at [phone number]."
                  :maxlength="80"
                  required
                )
            v-layout(row wrap)
              v-flex(xs12).pb-0
                div.inline-content Privacy Policy link:
              v-flex(xs4)
                v-text-field(
                  v-model="form.privacyPolicyText"
                  :rules="[rules.required]"
                  label="Text"
                  placeholder="Privacy Policy"
                  :maxlength="50"
                  required
                )
              v-flex(xs8)
                v-text-field(
                  v-model="form.privacyPolicyLink"
                  :rules="[rules.required]"
                  label="Link"
                  placeholder="Paste web address here"
                  :maxlength="300"
                  required
                )
          v-flex(xs6).pl-4
            v-layout(row wrap)
              v-flex(xs12)
                div.inline-content Preview:
              v-flex(xs12 sm12 md12 lg8 xl8)
                p.box.pa-4.mt-3 By submitting this form and checking this box, you agree to receive promotional messages from <strong>{{ form.brandName }}</strong>. This agreement isn't a condition of any purchase. Message frequency varies, and data rates may apply. Reply STOP to opt out. <strong>{{ form.customerCareContact | valueOrPlaceholder('[Customer care contact information]') }}</strong> View 
                  a(:href="form.privacyPolicyLink" target="_blank") {{ form.privacyPolicyText | valueOrPlaceholder('[Privacy Policy]') }}
        v-layout(wrap)
          v-flex(xs12).text-center
            v-btn(
              color='primary'
              @click="submit"
              :loading="isSaveDataLoading"
            ).submit-btn.ma-0 Save and Generate Link
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: 'OptInFormBuilder',
  data() {
    return {
      form: {
        customerCareContact: '',
        privacyPolicyText: '',
        privacyPolicyLink: '',
        brandName: '',
      },
      valid: false,
      rules: {
        required: value => !!value || 'This field is required.',
      },
    };
  },
  computed: {
    ...mapState('optInFormBuilder', [
      'isFormDataLoading',
      'isSaveDataLoading',
      'data',
      'formURL',
    ]),
  },
  mounted() {
    this.loadData();
  },
  filters: {
    valueOrPlaceholder(value, placeholder) {
      return value || placeholder;
    },
  },
  methods: {
    ...mapActions('optInFormBuilder', [
      'getData',
      'saveData',
      'getOptInFormLink',
    ]),
    async submit() {
      if (this.$refs.form.validate()) {
        await this.saveData(this.form);
        await this.getOptInFormLink();
      }
    },
    async loadData() {
      await this.getData();
      this.form.customerCareContact = this.data.customerCareContact;
      this.form.privacyPolicyText = this.data.privacyPolicyText;
      this.form.privacyPolicyLink = this.data.privacyPolicyLink;
      this.form.brandName = this.data.businessName;

      this.$nextTick(() => {
        this.$refs.form.resetValidation();
      });

      if (this.form.customerCareContact && this.form.privacyPolicyText && this.form.privacyPolicyLink) {
        this.getOptInFormLink();
      }
    },
  },
}
</script>
<style lang="scss">
.inline-content {
  display: flex;
}
.card {
  display: flex;
  flex-direction: row;
  padding: 32px;
}
.box {
  background-color: #dee7f1;
  border-radius: 10px;
  font-weight: 500;
  font-size: 16px;
}
.link {
  overflow-wrap: break-word;
  word-wrap: break-word;
  white-space: pre-wrap;
}
.skeleton-loader {
  background: url("/static/img/cell-skeleton-loader.svg"), repeating-linear-gradient(#fdfdfd, #fdfdfd 47px, #dddddd 48px);
  background-size: 100% 48px, auto;
  height: 47px;
}

.skeleton-box {
  background: url("/static/img/cell-skeleton-loader.svg"), repeating-linear-gradient(#fdfdfd, #fdfdfd 139px, #dddddd 140px);
  background-size: 100% 140px, auto;
  height: 139px;
}
</style>